class Customer {
  customerId: string;
  customerType: string;
  description: string;
  email: string;
  phoneNumber: string;
  website: string;

  constructor(
    customerId: string,
    customerType: string,
    description: string,
    email: string,
    phoneNumber: string,
    website: string,
  ) {
    this.customerId = customerId;
    this.customerType = customerType;
    this.description = description;
    this.email = email;
    this.phoneNumber = phoneNumber;
    this.website = website;
  }
}

export { Customer };
